module.exports = __webpack_public_path__ + "img/Fish.845a00e3.webp";